<ng-container *ngIf="page as page">
    <div class="p2-export-proc__column">
        <tt-card class="p2-export-proc__info" ttHeading="h_info" ttAccordion ttRememberId="p2exportproc.info">
            <tt-input ttLabel="p2_exportproc_name" [(ttModel)]="page.p2_exportproc_name"></tt-input>
            <tt-select ttLabel="grid_count" [(ttModel)]="page.grid_count">
                <tt-option ttValue="1">1</tt-option>
                <tt-option ttValue="2">2</tt-option>
                <tt-option ttValue="3">3</tt-option>
            </tt-select>
            <tt-input ttLabel="proc_name" [(ttModel)]="page.proc_name"></tt-input>
            <tt-input *ngIf="+page.grid_count > 1" ttLabel="proc_name_2" [(ttModel)]="page.proc_name_2"></tt-input>
            <tt-input *ngIf="+page.grid_count > 2" ttLabel="proc_name_3" [(ttModel)]="page.proc_name_3"></tt-input>
            <tt-select ttLabel="p2_importproc" [(ttModel)]="page.p2_importproc_keyno" [ttData]="importProcedures"></tt-select>
            <tt-select
                ttLabel="edi_destination"
                [(ttModel)]="page.edi_destination_keyno"
                [ttData]="ediDestinations"
                [ttShowClearButton]="page.edi_destination_keyno !== '0'"
                ttClearValue="0"
            ></tt-select>
            <tt-select ttLabel="edi_type" [(ttModel)]="page.edi_type_keyno" [ttData]="ediTypes" ttDataId="edi_type_keyno" ttDataName="edi_type_name"></tt-select>
            <tt-checkbox ttLabel="edi_autocreate" [(ttModel)]="page.autocreate"></tt-checkbox>
            <tt-select ttLabel="table_name" [(ttModel)]="page.table_name" [ttData]="tableNames" ttDataId="table_name" ttDataName="table_name_translated"></tt-select>
            <tt-checkbox ttLabel="isactive" [(ttModel)]="page.isactive"></tt-checkbox>
            <tt-checkbox ttLabel="gridexport" [(ttModel)]="page.gridexport"></tt-checkbox>
            <tt-checkbox ttLabel="show_table_name_export" [(ttModel)]="page.show_table_name_export"></tt-checkbox>
            <tt-checkbox *ngIf="page.gridexport === '1'" ttLabel="autoretrieve" [(ttModel)]="page.autoretrieve"></tt-checkbox>
            <tt-checkbox ttLabel="csvexport" [(ttModel)]="page.csvexport"></tt-checkbox>
            <tt-select ttLabel="tailoraccess" [(ttModel)]="page.tailoraccess_keyno" [ttData]="tailorAccesses" [ttShowClearButton]="page.tailoraccess_keyno !== '0'" ttClearValue="0">
                <ng-container buttons>
                    <tt-form-field-button ttIcon="fas fa-bars" ttGoto="tailoraccesses"></tt-form-field-button>
                </ng-container>
            </tt-select>
        </tt-card>

        <tt-card class="p2-export-proc__save">
            <tt-button-save ttText="save" (ttClick)="save()" [ttLoading]="saving" ttTextAlign="center"></tt-button-save>
        </tt-card>
    </div>

    <div class="p2-export-proc__column">
        <tt-card class="p2-export-proc__criteria" [ttHeading]="page.h_selection_criteria" [ttTranslateHeading]="false" ttAccordion ttRememberId="p2exportproc.selection-criteria">
            <tt-checkbox ttLabel="show_retrievearguments" [(ttModel)]="page.show_retrievearguments"></tt-checkbox>

            <ng-container *ngIf="page.show_retrievearguments === '1'">
                <tt-checkbox ttLabel="show_arg_datefomtom" [(ttModel)]="page.show_arg_datefomtom"></tt-checkbox>
                <tt-input *ngIf="page.show_arg_datefomtom === '1'" ttLabel="helptext_datefomtom" [(ttModel)]="page.helptext_datefomtom"></tt-input>
                <tt-checkbox ttLabel="show_arg_businessco_no" [(ttModel)]="page.show_arg_businessco_no"></tt-checkbox>
                <tt-checkbox ttLabel="show_arg_stockplace_id" [(ttModel)]="page.show_arg_stockplace_id"></tt-checkbox>
                <tt-checkbox ttLabel="show_arg_searchtext" [(ttModel)]="page.show_arg_searchtext"></tt-checkbox>
                <tt-input *ngIf="page.show_arg_searchtext === '1'" ttLabel="helptext_searchtext" [(ttModel)]="page.helptext_searchtext"></tt-input>
                <tt-checkbox ttLabel="show_arg_pricelist_id" [(ttModel)]="page.show_arg_pricelist_id"></tt-checkbox>
                <tt-checkbox ttLabel="show_arg_supplier_no" [(ttModel)]="page.show_arg_supplier_no"></tt-checkbox>
                <tt-checkbox ttLabel="show_arg_project_keyno" [(ttModel)]="page.show_arg_project_keyno"></tt-checkbox>
                <tt-checkbox ttLabel="show_arg_cust_no" [(ttModel)]="page.show_arg_cust_no"></tt-checkbox>
                <tt-checkbox ttLabel="show_arg_labour_no" [(ttModel)]="page.show_arg_labour_no"></tt-checkbox>
                <tt-checkbox ttLabel="show_arg_orderstatus_id" [(ttModel)]="page.show_arg_orderstatus_id"></tt-checkbox>
                <tt-checkbox ttLabel="show_arg_ordertype_id" [(ttModel)]="page.show_arg_ordertype_id"></tt-checkbox>
                <tt-checkbox ttLabel="show_arg_businesssite_keyno" [(ttModel)]="page.show_arg_businesssite_keyno"></tt-checkbox>
                <tt-checkbox ttLabel="show_order_order_no" [(ttModel)]="page.show_order_order_no"></tt-checkbox>
                <tt-checkbox ttLabel="show_collection_name" [(ttModel)]="page.show_collection_name"></tt-checkbox>
                <tt-checkbox ttLabel="show_arg_coop_id" [(ttModel)]="page.show_arg_coop_id"></tt-checkbox>
                <tt-checkbox ttLabel="show_activestatus_id" [(ttModel)]="page.show_activestatus_id"></tt-checkbox>
            </ng-container>
        </tt-card>

        <tt-card *ngIf="page.gridexport === '1'" class="p2-export-proc__menu" [ttHeading]="page.h_show_in_menu" [ttTranslateHeading]="false" ttAccordion ttRememberId="p2exportproc.menu">
            <tt-checkbox ttLabel="show_in_menu" [(ttModel)]="page.show_in_menu"></tt-checkbox>
            <tt-select
                *ngIf="page.show_in_menu === '1'"
                ttLabel="p2_webpage_menu_name"
                [(ttModel)]="page.p2_webpage_keyno"
                [ttData]="webpages"
                [ttShowClearButton]="page.p2_webpage_keyno !== '0'"
                ttClearValue="0"
            ></tt-select>
        </tt-card>
    </div>
</ng-container>
